module.exports = __webpack_public_path__ + "assets/img/activity-time-21fd4942.png";